export function DeleteIcon({ width = "17", height = "20" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.16663 5.00033H2.83329M2.83329 5.00033H16.1666M2.83329 5.00033V16.667C2.83329 17.109 3.00889 17.5329 3.32145 17.8455C3.63401 18.1581 4.05793 18.3337 4.49996 18.3337H12.8333C13.2753 18.3337 13.6992 18.1581 14.0118 17.8455C14.3244 17.5329 14.5 17.109 14.5 16.667V5.00033H2.83329ZM5.33329 5.00033V3.33366C5.33329 2.89163 5.50889 2.46771 5.82145 2.15515C6.13401 1.84259 6.55793 1.66699 6.99996 1.66699H10.3333C10.7753 1.66699 11.1992 1.84259 11.5118 2.15515C11.8244 2.46771 12 2.89163 12 3.33366V5.00033M6.99996 9.16699V14.167M10.3333 9.16699V14.167"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
